import { CustomMetadataStorage } from './custom-metadata-storage';
/**
 * Default metadata storage is used as singleton and can be used to storage all metadatas.
 */
export const customMetadataStorage = new CustomMetadataStorage();